import React from 'react'
import fetch from 'isomorphic-fetch'
import LadderCharacter from '../ladder-character'
import LadderMenu from '../ladder-menu'
import { Grid, Tabs, Tab, Spinner, Icon } from 'react-mdl'

const modes = ['standard', 'hardcore', 'exp', 'exphardcore'];
const modeNames = ['Standard', 'Hardcore', 'Exp', 'Exp Hc'];

export default class ArchivedLadder extends React.Component {

    state = {
        characters: null,
        id: null,
        activeMode: 3,
        errorOccurred: false,
        invalidMode: false
    }

    constructor(props) {
        super(props);

        var modeID = modes.indexOf(this.props.params.mode);

        if(modeID < 0) {
            this.state = {
                invalidMode: true
            };
        }
        else {
            this.state = {
                id: this.props.params.id,
                activeMode: modeID
            };
        }
    }

    componentDidUpdate() {
      if(!this.state.characters && !this.state.errorOccurred) {
          this.loadCharacters();
      }
    }

    componentDidMount() {
      document.title = "Archived ladder";
      this.loadCharacters();
    }

    loadCharacters() {
        fetch('https://ladder.slashdiablo.net/ladder/archived/'+this.props.params.id+'?mode='+modes[this.state.activeMode])
        .then((response) => {
            if (response.status >= 400) {
                throw new Error("Something went terribly wrong");
            }
            return response.json();
        })
        .then((response) => {
            this.setState({
                characters: response.characters,
                errorOccurred: false
            });
        })
        .catch((e) => {
            this.setState({
                errorOccurred: true
            });
        });
    }

    reload(modeId) {
        window.location.href = `/archived-ladder/${this.state.id}/${modes[modeId]}`
    }

    render() {

        if(this.state.invalidMode) {
            return (
                <div className="broadcast">
                    <Icon name="power" />
                    <h1 className="broadcast-text">Invalid mode, please try again.</h1>
                </div>
            );
        }

        if(this.state.errorOccurred) {
            return (
                <div className="broadcast">
                    <Icon name="power" />
                    <h1 className="broadcast-text">Something went terribly wrong, please try again.</h1>
                </div>
            );
        }

        if(!this.state.characters) {
            return (
                <div className="broadcast">
                    <Spinner />
                    <h1 className="broadcast-text">Crunching the numbers just for you.</h1>
                </div>
            );
        }

        return (
            <div>
                <LadderMenu/>
                <Tabs activeTab={this.state.activeMode} onChange={(modeId) => this.reload(modeId)} ripple>
                    {modeNames.map((tabName) => {
                        return <Tab key={tabName}>{tabName}</Tab>;
                    })}
                </Tabs>
                <section className="content">
                <Grid className="ladder-characters">
                    { this.state.characters.map((character) =>
                        <LadderCharacter key={(character.type+character.name)} data={character} />
                    )}
                </Grid>
                </section>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/archived-ladder/index.jsx
 **/